import { Icon } from '@iconify/react';
import { useEffect, useState } from 'react';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { href: '#beranda', label: 'Beranda' },
    { href: '#loker', label: 'Loker' },
    { href: '#fitur', label: 'Fitur' },
    { href: '#harga', label: 'Harga' },
    { href: '#tentang', label: 'Tentang Kami' },
    { href: '#faq', label: 'FAQ' },
  ];

  return (
    <nav className={`glass-nav fixed top-0 left-0 right-0 z-50 h-16 transition-all ${
      isScrolled ? 'shadow-sm' : ''
    }`}>
      <div className="max-w-7xl mx-auto px-6 h-full flex items-center justify-between">
        {/* ===== LOGO ===== */}
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 rounded-lg gradient-btn flex items-center justify-center">
            <Icon icon="mdi:hexagon-multiple" className="text-white text-lg" />
          </div>
          <span className="text-xl font-bold text-zentra-800">ZENTRA</span>
        </div>

        {/* ===== DESKTOP MENU ===== */}
        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className={`text-sm font-medium transition-colors ${
                link.href === '#loker'
                  ? 'text-zentra-600 font-semibold'
                  : 'text-gray-600 hover:text-zentra-600'
              }`}
            >
              {link.label}
            </a>
          ))}
        </div>

        {/* ===== DESKTOP BUTTONS ===== */}
        <div className="hidden md:flex items-center gap-3">
          <button className="text-sm font-medium text-zentra-600 hover:text-zentra-700 transition-colors px-4 py-2">
            Masuk
          </button>
          <button className="gradient-btn text-white text-sm font-semibold px-5 py-2.5 rounded-lg transition-all hover:shadow-lg hover:shadow-zentra-500/25">
            Daftar Gratis
          </button>
        </div>

        {/* ===== MOBILE MENU BUTTON ===== */}
        <button
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          className="md:hidden p-2 rounded-lg hover:bg-zentra-50 transition-colors"
          aria-label="Toggle menu"
        >
          <Icon
            icon={isMenuOpen ? 'mdi:close' : 'mdi:menu'}
            className="text-xl text-gray-700"
          />
        </button>
      </div>

      {/* ===== MOBILE MENU DROPDOWN ===== */}
      {isMenuOpen && (
        <div className="md:hidden absolute top-16 left-0 right-0 bg-white border-b border-gray-100 shadow-lg animate-slide-down">
          <div className="px-6 py-4 flex flex-col gap-3">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className={`text-sm font-medium py-2 transition-colors ${
                  link.href === '#loker'
                    ? 'text-zentra-600 font-semibold'
                    : 'text-gray-600 hover:text-zentra-600'
                }`}
                onClick={() => setIsMenuOpen(false)}
              >
                {link.label}
              </a>
            ))}
            <div className="flex gap-3 pt-2 border-t border-gray-100">
              <button className="text-sm font-medium text-zentra-600 px-4 py-2 hover:text-zentra-700 transition-colors">
                Masuk
              </button>
              <button className="gradient-btn text-white text-sm font-semibold px-5 py-2.5 rounded-lg transition-all hover:shadow-lg hover:shadow-zentra-500/25">
                Daftar Gratis
              </button>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
